<ng-container [ngSwitch]="!!metrics">
  <ng-container *ngSwitchCase="true">
    <div class="grid-container" [class.limited-access]="limitedAccessMode">
      <app-insights-metric
        *ngFor="let metric of metrics"
        class="grid-item overview-metric"
        [type]="metric.type"
        [label]="metric.label"
        [data]="metric.data"
        [cta]="metric.cta"
        [ctaDialog]="metric.ctaDialog"
        [trackingObject]="trackingObject"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        [trackingScreenName]="trackingScreenName"
        [limitedAccessMode]="limitedAccessMode"
      >
      </app-insights-metric>
    </div>

    <div
      *ngIf="showSummaryCards && (isReportsDataReady$ | async)"
      class="grid-container half summary-cards-container"
    >
      <app-insights-summary-card
        *ngFor="let reportType of defaultReports"
        [reportType]="reportType"
        [trackingScreenName]="trackingScreenName"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        class="grid-item"
      ></app-insights-summary-card>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="grid-container" [class.limited-access]="limitedAccessMode">
      <div
        *ngFor="let i of numberOfPlaceholderMetrics | fill"
        class="placeholder-contents"
      >
        <div
          *ngIf="!limitedAccessMode"
          class="placeholder-header shimmer"
        ></div>
        <div class="placeholder-body shimmer"></div>
      </div>
    </div>
  </ng-container>
</ng-container>
